// extracted by mini-css-extract-plugin
export default {"products":"products_products__-xDPv"};